/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit AppointmentNoShows/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function AppointmentNoShows({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentCard/Summary/Content/Content/Reporting/Content/AppointmentNoShows"
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtTypographyFontsizeM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'typography.fontSize.m'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtColorsNeutral700 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.700'
        })
let statisticsAppointmentNoShowsValueData = fromData.useDataValue({ viewPath,
context: 'statistics',
path: 'appointment_no_shows',
})
let dtTypographyFontweightBold = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'typography.fontWeight.bold'
        })
  return (<React.Fragment
>
<div
  data-testid="AppointmentNoShows.Horizontal"
  data-view-path={viewPath}
 style={{'--mt-1-ZxGTIY': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="No shows:"
 fontSize={dtTypographyFontsizeM}
 marginLeft={dtSpaceXxs}
 color={dtColorsNeutral700}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="statistics.appointment_no_shows"
 text={statisticsAppointmentNoShowsValueData}
 marginLeft={dtSpaceXs}
 fontWeight={dtTypographyFontweightBold}
/>
</div>
{children}
</React.Fragment>)
}